import React from 'react'
import TopPanelMenu from 'components/TopPanelMenu'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {getSelectedDateRange} from 'redux/modules/currentUser/selectors'
import Loader from 'components/Loader'
import {
  exportIncommingData,
  exportSessionMappingData
} from 'redux/modules/insights/actions'
import {exportUmmapImpressionData} from 'redux/modules/settings/actions'
import classnames from 'classnames'

class DataCollectionMenu extends React.Component {
  static propTypes = {
    exportIncommingData: PropTypes.func,
    exportUmmapImpressionData: PropTypes.func,
    exportSessionMappingData: PropTypes.func,
    location: PropTypes.object.isRequired
  }

  static contextTypes = {
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  state = {
    isLoading: false
  }

  render() {
    return (
      <div className='data-collection-menu'>
        <TopPanelMenu
          items={[
            {
              to: '/data-collection',
              title: 'Incomming Data',
              onlyActiveOnIndex: true
            },
            {to: '/data-collection/impressions', title: 'Impressions'},
            {
              to: '/data-collection/source-mapping',
              title: 'Source Mapping Data'
            }
          ]}
        />
        {this.renderExportButton()}
      </div>
    )
  }

  renderExportButton() {
    const {isLoading} = this.state

    const className = classnames('is-normal data-collection-menu_button', {
      'is-loading': isLoading
    })
    return (
      <button className={className} onClick={this.handleExport}>
        {isLoading ? (
          <>
            Export
            <Loader />
          </>
        ) : (
          'Export'
        )}
      </button>
    )
  }

  handleExport = () => {
    if (this.state.isLoading) {
      return
    }

    this.setState({isLoading: true})

    const {location} = this.props

    this.setState({isLoading: true})
    let prm
    if (location.pathname === '/data-collection/impressions') {
      this.props.exportUmmapImpressionData()
    } else if (location.pathname === '/data-collection/source-mapping') {
      prm = this.props.exportSessionMappingData(this.context.timezone)
    } else {
      this.props.exportIncommingData()
    }

    if (prm) {
      prm.success(() => {
        this.setState({isLoading: false})
      })
    } else {
      this.setState({isLoading: false})
    }
  }
}

const mapStateToProps = state => {
  const {startDate, endDate} = getSelectedDateRange(state)

  return {
    startDate,
    endDate,
    filters: state.orders.filters,
    sessions: state.orders.sessions
  }
}

const mapDispatchToProps = {
  exportIncommingData,
  exportUmmapImpressionData,
  exportSessionMappingData
}

export default connect(mapStateToProps, mapDispatchToProps)(DataCollectionMenu)



// WEBPACK FOOTER //
// ./client/views/DataCollectionView/menu.js